import { BASE_URL } from "@/services/api/base";

export const getContractsEndpoint = `${BASE_URL}/LoaContracts/Get`;
